import { InputProps as ChakraInputProps } from '@chakra-ui/react';

import { FormFieldUncontrolledComponent } from '../../types/fields';

type LabelOnlyProps = ChakraInputProps;

export const LabelOnly: FormFieldUncontrolledComponent<LabelOnlyProps> = () =>
  null;

LabelOnly.controlled = false;
LabelOnly.displayName = 'LabelOnly';
